import { Button, Divider, Input, Typography } from "antd"
import { useState } from "react";
import { Link } from "react-router-dom"
import CustomModal from "../CustomModal/CustomModal"

const HeaderComp = ({ title, btnType, path, popupContnent, onSearch = false, onOk, open, isOpen, close }) => {
    const adddBtnStyle = {
        background: "var(--color-blue)", color: "var(--color-white)",
        borderRadius: 4,
        width: 100,
    }


    const showModal = () => {
        open()
    };
    const handleOk = () => {
        onOk()
        close()
    };
    const handleCancel = () => {
        console.log('Clicked cancel button');
        close();
    };
    return (
        <div style={{ width: "100%", padding: "0 10px", marginBottom: 15 }}>
            <div className="flex_space_between" style={{ flexWrap: 'wrap' }}>
                <Typography.Title level={3}>{title}</Typography.Title>
                {onSearch && (
                    <>  <Input
                        placeholder="Search..."
                        // onSearch={onSearch}
                        onChange={onSearch}
                        style={{
                            width: 200,
                        }}

                    /></>
                )}

                {btnType && btnType === 'link' && (
                    <Link to={path}>
                        <Button style={adddBtnStyle}> +Add </Button>
                    </Link>
                )}
                {btnType && btnType === 'popup' && (
                    <>
                        <Button style={adddBtnStyle} onClick={showModal}> +Add </Button>
                        <CustomModal title={popupContnent.title} open={isOpen} handleOk={handleOk} handleCancel={handleCancel} >
                            {popupContnent.body}
                        </CustomModal>
                    </>
                )}
            </div>
            <Divider style={{ margin: "5px 0" }} />
        </div>
    )
}
export default HeaderComp